import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import { EndDateField, StartDateField } from './DateTimeField'

interface Props extends PermissionsProps, CustomizationProps {
  loading: boolean
}

const DateTimeRange = (props: Props) => {
  return (
    <Box flexDirection="column" gap="s8">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {i18n.t('expenses_v2.per_diem.travel_dates.title')}
      </Text.Normal>
      <Box flexDirection="column" justifyContent="spaceBetween" gap="s16">
        <StartDateField {...props} isFieldMandatory fieldIdentifier="start_date" />
        <EndDateField {...props} isFieldMandatory fieldIdentifier="end_date" />
      </Box>
    </Box>
  )
}

export default DateTimeRange
